import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { TaxesOverlayService } from './taxes-overlay.service'
import { TaxesOverlayComponent } from './taxes-overlay.component'
import { ReactiveFormsModule } from '@angular/forms'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatSelectModule } from '@angular/material/select'
import { MatInputModule } from '@angular/material/input'
import { AmountPlaceholderModule, Tv3PlatformModule } from '@tokeet/tv3-platform'
import { MatTableModule } from '@angular/material/table'
import { MatPaginatorModule } from '@angular/material/paginator'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatSortModule } from '@angular/material/sort'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { TaxFormComponent } from './tax-form/tax-form.component'

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    AmountPlaceholderModule,
    Tv3PlatformModule,
    MatTableModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatSortModule,
    MatCheckboxModule,
    MatAutocompleteModule,
  ],
  declarations: [TaxesOverlayComponent, TaxFormComponent],
  providers: [TaxesOverlayService],
  exports: [TaxesOverlayComponent, TaxFormComponent],
})
export class RentalTaxesModule {}
